// Category Action Types
export const FETCH_CATEGORIES_REQUEST = 'category/FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'category/FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'category/FETCH_CATEGORIES_FAILURE';

export const CREATE_CATEGORY_REQUEST = 'category/CREATE_CATEGORY_REQUEST';
export const CREATE_CATEGORY_SUCCESS = 'category/CREATE_CATEGORY_SUCCESS';
export const CREATE_CATEGORY_FAILURE = 'category/CREATE_CATEGORY_FAILURE';

export const UPDATE_CATEGORY_REQUEST = 'category/UPDATE_CATEGORY_REQUEST';
export const UPDATE_CATEGORY_SUCCESS = 'category/UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAILURE = 'category/UPDATE_CATEGORY_FAILURE';

export const DELETE_CATEGORY_REQUEST = 'category/DELETE_CATEGORY_REQUEST';
export const DELETE_CATEGORY_SUCCESS = 'category/DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILURE = 'category/DELETE_CATEGORY_FAILURE';

export const FETCH_CATEGORY_DETAILS_REQUEST = 'category/FETCH_CATEGORY_DETAILS_REQUEST';
export const FETCH_CATEGORY_DETAILS_SUCCESS = 'category/FETCH_CATEGORY_DETAILS_SUCCESS';
export const FETCH_CATEGORY_DETAILS_FAILURE = 'category/FETCH_CATEGORY_DETAILS_FAILURE';

export const RESET_CATEGORY_STATE = 'category/RESET_CATEGORY_STATE';
